import { Component, OnInit, ViewChild, OnChanges, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage";
import { VamTitularesService } from './vam-titulares.service';
import { VamTitularEntity, SiniestrosVamTit, SiniestroVam } from './entities/vam_titulares_entity';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';
import { SiniestroTracking, SiniestroTrackingVam } from '../../siniestros/siniestros_entity';
import { DocumentoReclamo, DocumentoTracking } from '../vam_entity';
import { ConstantService } from '../../../components/common/utils/constant.service';

const swal = require("sweetalert2");


declare var jQuery: any;

@Component({
  selector: 'vamTracking',
  templateUrl: 'vam-tracking.template.html',
  styleUrls: ["vam-titulares.style.css"]
})
export class VamTrackingComponent implements OnInit, OnChanges {
  @Input()
  trackingVam: SiniestroTrackingVam;

  @Input()
  siniestro: SiniestroVam;

  resultadoTracking: SiniestroTrackingVam;

  reporteRecibido: boolean;
  documentacion: boolean;
  inspeccion: boolean;
  autorizacionReparacion: boolean;
  reparacion: boolean;
  cierre: boolean;

  link_reporteRecibido: boolean;
  link_documentacion: boolean;
  link_inspeccion: boolean;
  link_autorizacionReparacion: boolean;
  link_reparacion: boolean;
  link_cierre: boolean;

  current: number;
  docsCliente: DocumentoReclamo[] = new Array<DocumentoReclamo>();
  files: File[] = [];
  formData: FormData = new FormData();
  devolverMensaje: any;
  url: string = "utils";
  showLoader: string = "";

  ngOnInit() {
    this.resultadoTracking = this.trackingVam;
  }
  ngOnChanges() {
    this.resultadoTracking = this.trackingVam;
    if (this.resultadoTracking.DetalleSiniestro != null) {
      this.reporteRecibido = true;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_reporteRecibido = true;
    } else {
      this.link_reporteRecibido = false;
    }
    if (this.resultadoTracking.DocumentosPendientes != null) {
      this.reporteRecibido = false;
      this.documentacion = true;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = false;
      this.link_documentacion = true;
    } else {
      this.link_documentacion = false;
    }
    if (this.resultadoTracking.Cobertura != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = true;
      this.reparacion = false;
      this.cierre = false;
      this.link_autorizacionReparacion = true;
    } else {
      this.link_autorizacionReparacion = false;
    }
    if (this.resultadoTracking.Liquidacion != null) {
      this.reporteRecibido = false;
      this.documentacion = false;
      this.inspeccion = false;
      this.autorizacionReparacion = false;
      this.reparacion = false;
      this.cierre = true;
      this.link_cierre = true;
    } else {
      this.link_cierre = false;
    }
  }
  constructor(
    private sesionStorageService: SessionStorageService,
  ) {
    this.reporteRecibido = false;
    this.documentacion = false;
    this.inspeccion = false;
    this.autorizacionReparacion = false;
    this.reparacion = false;
    this.cierre = false;

    this.link_reporteRecibido = false;
    this.link_documentacion = false;
    this.link_inspeccion = false;
    this.link_autorizacionReparacion = false;
    this.link_reparacion = false;
    this.link_cierre = false;

    this.resultadoTracking = new Object();
    let constantService = new ConstantService();
    this.url = constantService.API_ENDPOINT + this.url;

    this.devolverMensaje = (parametro: number, documento: any): void => {
      if (parametro == 200) {
        let rcl = JSON.parse(documento);
        swal({
          title: 'Actualizar Documentación',
          text: "Su información ha sido enviada satisfactoriamente",
          type: 'success'
        }).then(()=>{
          window.location.reload();
        });

        this.docsCliente = new Array<DocumentoReclamo>();
        this.showLoader = "";
        this.formData = new FormData();
      }
      else {
        swal({
          title: 'Actualizar Documentación',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
        this.showLoader = "";
        this.formData = new FormData();
      }
    }
  }
  accion(paso: number) {
    switch (paso) {
      case 1:
        this.reporteRecibido = true;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 2:
        this.reporteRecibido = false;
        this.documentacion = true;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 3:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = true;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 4:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = true;
        this.reparacion = false;
        this.cierre = false;
        break;
      case 5:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = true;
        this.cierre = false;
        break;
      case 6:
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = true;
        break;
    }
  }
  CrearDocumento(tipCod: number) {
    let a = this.docsCliente.length;
    let codigo = 1;

    codigo =
      Math.max.apply(
        Math,
        this.docsCliente.map(function (o) {
          return o.Codigo;
        })
      ) + 1;
    if (!isFinite(codigo)) {
      codigo = 1;
    }

    let doc = new DocumentoReclamo();
    doc.TipoDocumento = tipCod;
    doc.Codigo = codigo;
    this.docsCliente.push(doc);
  }

  fileChange(archivo: any, doc: DocumentoReclamo) {
    let archivoEncontrado = undefined;
    if (this.files != undefined) {
      archivoEncontrado = this.files.filter(a => a.name == archivo.target.files[0].name);
    }
    if (archivoEncontrado != null && archivoEncontrado != undefined && archivoEncontrado.length > 0) {
      swal({
        title: 'Archivo ',
        text: "El nombre de archivo ya existe, por favor modifique su nombre",
        type: 'error'
      });
    } else {
      doc.NombreArchivo = archivo.target.files[0].name;
      doc.TipoMIME = archivo.target.files[0].type;
      this.files.push(archivo.target.files[0]);
    }
  }
  eliminarArchivo(doc: DocumentoReclamo) {
    this.docsCliente = JSON.parse(JSON.stringify(this.docsCliente.filter(a => a.Codigo != doc.Codigo)));
    this.files = this.files.filter(a => a.name != doc.NombreArchivo);
  }

  EnviarDocumentos() {
    this.showLoader = "sk-loading";


    this.files.forEach(a => {
      this.formData.append(a.name, a, a.name);
    })

    let documentacion = new DocumentoTracking();
    documentacion.CodigoSiniestro = this.siniestro.TipoManejo == 1 ? this.siniestro.CodigoTracking : this.siniestro.CodigoSiniestro;
    documentacion.TipoManejo = this.siniestro.TipoManejo;
    documentacion.DocumentosReclamo = this.docsCliente;

    this.formData.append("documentos", JSON.stringify(documentacion));


    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = (function () {
      if (xhr.readyState === 4) {
        this.devolverMensaje(xhr.status, xhr.response);
      }
    }).bind(this);
    xhr.open("post", this.url + '/GetGuardarReclamo', true);
    xhr.setRequestHeader("enctype", "multipart/form-data");
    // IE workaround for Cache issues
    xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.setRequestHeader("Cache-Control", "no-store");
    xhr.setRequestHeader("Pragma", "no-cache");
    xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
    xhr.setRequestHeader("documentos", JSON.stringify(documentacion));

    xhr.send(this.formData);
  }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/titulares/vam-tracking.component.ts